//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  name: 'user-alert',
  props: {
    alertInfo: {
      successImg: {
        type: String,
        default: ''
      },
      imgUrl: '',
      text: {
        type: String,
        default: ''
      },
      callBack: {
        type: Function,
        default: function _default() {}
      }
    }
  },
  data: function data() {
    return {
      imgUrl: '',
      timer: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.init();
  },
  methods: {
    init: function init() {
      var _this = this;

      this.timer = setTimeout(function () {
        _this.$emit('clearFn');

        clearTimeout(_this.timer);

        if (_this.alertInfo.callBack) {
          _this.alertInfo.callBack();
        }
      }, 3000);
    }
  },
  beforeDestroy: function beforeDestroy() {
    this.timer = null;
  }
};